import Layout from "../(others)/layout";
import ExpertiseTooltip from "components/Tooltip/ExpertiseTooltip";
import CurvedContainer from "../../components/CurvedContainer";
import Heading2 from "components/Heading/Heading2";
import "../../styles/styles.css";

const PageServices = () => {
  const imageSizes = [
    "h-48", // image la plus à gauche (basse)
    "h-64", // image entre gauche et centre (moyenne)
    "h-80", // image centrale (haute)
    "h-64", // image entre droite et centre (moyenne)
    "h-48", // image la plus à droite (basse)
  ];

  const imageFiles = [
    "Services1.jpg",
    "Services2.jpg",
    "Services3.jpg",
    "Services4.jpg",
    "Services5.jpg",
  ];

  return (
    <Layout>
      <CurvedContainer>
        <div style={{ color: "black" }} className="nc-PageAbout relative px-4">
          {/* Conteneur parent centré */}
          <div className="w-full flex justify-center mb-6">
            <Heading2
              style={{ color: "black" }}
              className="text-4xl font-semibold md:text-5xl"
            >
              Services
            </Heading2>
          </div>

          <div className="mb-4 flex justify-left">
            <ExpertiseTooltip />
          </div>

          {/* Conteneur principal responsive avec centrage vertical */}
          <div className="flex flex-col lg:flex-row gap-6 items-center">
            {/* Texte – 40% */}
            <div className="lg:w-[40%] w-full">
              <span
                style={{ fontSize: "20px", color: "black" }}
                className="block text-base xl:text-lg text-neutral-6000 dark:text-neutral-400"
              >
                Je propose des services de développement web modernes et adaptés à vos besoins, que ce soit pour un site vitrine personnel, une plateforme dynamique ou une application web connectée à une base de données.
                <br /><br />
                J’utilise des technologies de pointe telles que React, Node.js et d'autres outils performants pour créer des sites rapides, évolutifs et sécurisés. Chaque projet est conçu sur mesure pour répondre précisément à vos objectifs, avec une attention particulière portée à l’expérience utilisateur, à la performance et à la maintenance.
                <br /><br />
                Qu’il s’agisse de lancer votre présence en ligne ou de développer un système complet côté client et serveur, je vous accompagne de la conception à la mise en ligne.
                <br /><br />              
              </span>
            </div>

            {/* Images – 60% */}
            <div className="lg:w-[60%] w-full flex justify-center items-center flex-wrap">
              {imageFiles.map((src, i) => (
                <img 
                  key={i}
                  src={`../../images/${src}`}
                  alt={`Service ${i + 1}`}
                  className={`arrondie object-contain ${imageSizes[i]} max-w-[300px]`}
                />
              ))}
            </div>
          </div>
        </div>
      </CurvedContainer>
    </Layout>
  );
};

export default PageServices;
